export default {
  USER_EARNED_POINTS_TRANSACTIONS_LOAD: 'USER_EARNED_POINTS_TRANSACTIONS_LOAD',
  USER_EARNED_POINTS_TRANSACTIONS_FETCHED: 'USER_EARNED_POINTS_TRANSACTIONS_FETCHED',
};
